<div class="panel" [ngClass]="{ pin: pinned, open: isOpened }">
    <div class="data-wrapper">
        @if (!isLoading) {
            <ng-container>
                <dx-toolbar class="panel-toolbar">
                    <dxi-item location="before">
                        <span class="contact-name value">{{ formData.name }}</span>
                    </dxi-item>
                    <dxi-item location="before">
                        <contact-status [value]="formData.status"></contact-status>
                    </dxi-item>
                    <dxi-item location="after" [visible]="isPinEnabled">
                        <dx-button
                            stylingMode="text"
                            [icon]="pinned ? 'pin' : 'unpin'"
                            (onClick)="onPinClick()"
                        ></dx-button>
                    </dxi-item>
                    <dxi-item location="after">
                        <dx-button
                            icon="close"
                            stylingMode="text"
                            (onClick)="onClosePanel()"></dx-button>
                    </dxi-item>
                </dx-toolbar>

                <dx-scroll-view class="panel-scroll">
                    <dx-validation-group>
                        <div class="data-part border p-3">
                            <ng-content></ng-content>
                        </div>

                        <div class="data-part data-part-toolbar border">
                            <dx-toolbar>
                                <dxi-item location="after">
                                    <dx-button
                                        text="Search"
                                        icon="find"
                                        stylingMode="contained"
                                        type="default"
                                        (onClick)="search()"
                                    >
                                    </dx-button>
                                </dxi-item>
                                <dxi-item location="after">
                                    <dx-button
                                        text="Clear"
                                        stylingMode="outlined"
                                        type="normal"
                                        (onClick)="clear()"
                                    >
                                    </dx-button>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dx-validation-group>
                </dx-scroll-view>
            </ng-container>
        }

        <dx-load-panel
            container=".panel"
            [width]="300"
            [visible]="isLoading"
            [showPane]="false"
            [position]="{ of: '.panel' }"
        ></dx-load-panel>
    </div>
</div>
